import ShowProductsButtonView from "../view/show-products-button.js";

import ShowProductButtonModel from "../model/show-products-button.js";

import {
  render
} from "../../../render/render.js";

import {
  defaultShowProductsButtonModelData,
  ActionType
} from "../../const.js";
export default class ShowProductsButton {
  constructor(responsiveFilterView, changeFilter, initTotal) {
    this._responsiveFilterView = responsiveFilterView;
    this._changeFilter = changeFilter;
    this._initTotal = initTotal;

    this._showProductsButtonView = null;
    this._model = null;
    this._requestQueue = {};

    this._observers = {
      close: []
    };

    this._handleShowProductsButtonClick = this._handleShowProductsButtonClick.bind(this);
    this._handleChangeFilterLoad = this._handleChangeFilterLoad.bind(this);
    this._handleChangeData = this._handleChangeData.bind(this);
  }

  init() {
    this._changeFilter.addLoadObserver(this._handleChangeFilterLoad);
    this._model = new ShowProductButtonModel(Object.assign(
        {},
        defaultShowProductsButtonModelData,
        {
          total: this._initTotal
        }
    ));
    this._model.addObserver(this._handleChangeData);

    if (this._model.getData().isRendered) {
      return;
    }

    this._model.changeData(Object.assign(
        {},
        this._model.getData(),
        {
          isRendered: true
        }
    ), ActionType.RENDER_SHOW_PRODUCTS_BUTTON);
  }

  addCloseObserver(observer) {
    this._observers.close.push(observer);
  }

  _processButtonRender() {
    this._showProductsButtonView = new ShowProductsButtonView(this._model.getData().total);
    render(
        this._responsiveFilterView.getWrapper(),
        this._showProductsButtonView.getElement()
    );

    this._showProductsButtonView.setClickHandler(this._handleShowProductsButtonClick);
  }

  _processChangeTotal() {
    this._showProductsButtonView.setNumber(this._model.getData().total);
  }

  _handleChangeFilterLoad(data) {
    this._model.changeData(Object.assign(
        {},
        this._model.getData(),
        {
          total: data.total
        }
    ), ActionType.CHANGE_TOTAL);
  }

  _handleShowProductsButtonClick() {
    this._notifyClose();
  }

  _handleChangeData(action) {
    switch (action) {
      case ActionType.RENDER_SHOW_PRODUCTS_BUTTON:
        this._processButtonRender();
        break;
      case ActionType.CHANGE_TOTAL:
        this._processChangeTotal();
        break;
    }
  }

  _notifyClose() {
    this._observers.close.forEach((observer) => observer());
  }
}
